// gazet-preview.component.ts
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { GazetiDetail, GazetiPage } from '../landing.model';
import { GET_GAZETI_DETAIL, GET_GAZETI_PAGE_CONTENT } from '../landing.graphql';
import { animate, state, style, transition, trigger } from '@angular/animations';



@Component({
  selector: 'app-gazet-preview',
  templateUrl: './gazet-preview.component.html',
  styleUrls: ['./gazet-preview.component.scss'],
  standalone: false,
  animations: [
  trigger('pageSlide', [
  state('enterRight', style({ transform: 'translateX(0)', opacity: 1 })),
  state('enterLeft', style({ transform: 'translateX(0)', opacity: 1 })),
  transition('* => enterRight', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('500ms ease-out')
  ]),
  transition('* => enterLeft', [
    style({ transform: 'translateX(-100%)', opacity: 0 }),
    animate('500ms ease-out')
  ])
])

]


})
export class GazetPreviewComponent implements OnInit {
  private apollo = inject(Apollo);
  private route = inject(ActivatedRoute);
  private location = inject(Location);

  gazeti: GazetiDetail | null = null; // Header info
  page: GazetiPage | null = null;     // Current page content
  loading = true;
  loadingPage = false;
  error: string | null = null;
  gazetiUuid: string | null = null;
  currentPageNumber = 1;
  pageAnimationState: 'enterRight' | 'enterLeft' = 'enterRight';


  ngOnInit(): void {
    this.gazetiUuid = this.route.snapshot.paramMap.get('gazetiId');
    if (!this.gazetiUuid) {
      this.error = 'No gazeti ID provided';
      this.loading = false;
      return;
    }

    this.loadGazetiDetail(); // Load header info once
  }

  loadGazetiDetail(): void {
    this.loading = true;
    this.apollo
      .query<{ getGazetiDetail: any }>({
        query: GET_GAZETI_DETAIL,
        variables: { uuid: this.gazetiUuid },
      })
      .subscribe({
        next: ({ data }) => {
          const res = data.getGazetiDetail;
          if (res.response.status && res.data) {
            this.gazeti = res.data;
            this.loadPageContent(1); // Load first page after header
          } else {
            this.error = res.response.message;
            this.loading = false;
          }
        },
        error: () => {
          this.error = 'Failed to load gazeti';
          this.loading = false;
        },
      });
  }

  loadPageContent(pageNumber: number): void {
    this.loadingPage = true;
    this.apollo
      .query<{ getGazetiPageContent: any }>({
        query: GET_GAZETI_PAGE_CONTENT,
        variables: { gazetiUuid: this.gazetiUuid, pageNumber },
      })
      .subscribe({
        next: ({ data }) => {
          const res = data.getGazetiPageContent;
          if (res.response.status && res.data) {
            this.page = res.data;
            this.currentPageNumber = this.page.pageNumber;
          }
          this.loading = false;
          this.loadingPage = false;
        },
        error: () => {
          this.error = 'Failed to load page content';
          this.loadingPage = false;
        },
      });
  }

prevPage(): void {
  if (this.page?.hasPreviousPage && this.page.previousPageNumber) {
    this.pageAnimationState = 'enterLeft';
    this.loadPageContent(this.page.previousPageNumber);
  }
}

nextPage(): void {
  if (this.page?.hasNextPage && this.page.nextPageNumber) {
    this.pageAnimationState = 'enterRight';
    this.loadPageContent(this.page.nextPageNumber);
  }
}
goBack(): void {
    this.location.back();
  }




getImageUrl(filePath: string): string {
  if (!filePath) return 'assets/images/default-gazeti.jpg';

  // Case 1: Full uploads/media path
  if (filePath.startsWith('uploads/media')) {
    return `https://epaper.all.tz/${filePath}`;
  }
  // Case 2: Starts with media/
  else if (filePath.startsWith('media/')) {
    return `https://epaper.all.tz/uploads/${filePath}`;
  }
  // Case 3: UUID-style filenames (like your JSON)
  else {
    return `https://epaper.all.tz/uploads/media/${filePath}`;
  }
}




  onImageError(event: any) {
  const target = event.target as HTMLImageElement;
  

  if (!target.src.includes('default-gazeti.jpg')) {
    target.src = 'assets/images/default-gazeti.jpg'; 
  } else {
  
    target.style.display = 'none';
  }

  console.warn('Image failed to load:', event.target.src);
}
}